import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "login-footer" }
const _hoisted_2 = { class: "login-footer__actions" }
const _hoisted_3 = { class: "login-footer__action-primary" }
const _hoisted_4 = {
  key: 0,
  class: "login-footer__action-forgot"
}
const _hoisted_5 = {
  key: 1,
  class: "login-footer__action-login"
}
const _hoisted_6 = {
  key: 0,
  class: "login-footer__apps"
}
const _hoisted_7 = { class: "login-footer__apps-list" }
const _hoisted_8 = {
  class: "login-apps-button",
  href: "https://www.sazka.cz/sazka-klub/aplikace",
  "is-external": "true"
}
const _hoisted_9 = {
  class: "login-apps-button",
  href: "https://www.sazka.cz/sazka-klub/aplikace",
  "is-external": "true"
}

import { AuthenticationStepType } from "@/account/models/authentication-flows";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'login-footer',
  props: {
    authenticationStep: {}
  },
  emits: ["nextStep", "goToLoginPass", "login"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const ctaText = computed(() => {
    switch (props.authenticationStep) {
        case "LoginWelcome":
        case "LoginPhone":
        case "LoginPass":
            return "Přihlásit se";
        case "ForgPinGen":
            return "Odeslat PIN kód";
        case "ForgPinLog":
            return "Ověřit kód";
        case "ForgNewPass":
            return "Uložit heslo";
        case "ForgNewPassOk":
            return "Zavřít";
        default:
            return "Pokračovat";
    }
});

const primaryClickHandler = () => {
    if (props.authenticationStep == "LoginPass" || props.authenticationStep == "LoginWelcome") {
        emit("login");
    } else {
        emit("nextStep");
    }
};

const nextStep = () => {
    emit("nextStep");
};

const goToLoginPass = () => {
    emit("goToLoginPass");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-secondary login-footer__btn-primary",
          onClick: primaryClickHandler
        }, _toDisplayString(ctaText.value), 1)
      ]),
      (_ctx.authenticationStep == 'LoginPass' || _ctx.authenticationStep == 'LoginWelcome')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "login-footer__btn-forgot",
              type: "button",
              onClick: nextStep
            }, "Zapomněli jste heslo?")
          ]))
        : _createCommentVNode("", true),
      (_ctx.authenticationStep == 'ForgPinGen' || _ctx.authenticationStep == 'ForgPinLog')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createTextVNode(" Vzpomněli jste si na své heslo? ")),
            _createElementVNode("a", {
              class: "login-footer__btn-login",
              type: "button",
              onClick: goToLoginPass
            }, "Přihlaste se")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.authenticationStep == 'LoginWelcome')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "login-footer__apps-intro" }, "Sazka Klub nyní ve Vašem telefonu:", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _createVNode(WebpImage, {
                src: "/frontend/kasa-loyalty/img/icons/colored/app-android.svg",
                alt: `Ikona android`,
                cssClass: "login-apps-button__icon"
              }),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "login-apps-button__text" }, [
                _createElementVNode("div", { class: "login-apps-button__text--top" }, "Stáhnout pro"),
                _createElementVNode("div", { class: "login-apps-button__text--bottom" }, "Android")
              ], -1))
            ]),
            _createElementVNode("a", _hoisted_9, [
              _createVNode(WebpImage, {
                src: "/frontend/kasa-loyalty/img/icons/colored/app-ios.svg",
                alt: `Ikona iOS`,
                cssClass: "login-apps-button__icon"
              }),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "login-apps-button__text" }, [
                _createElementVNode("div", { class: "login-apps-button__text--top" }, "Stáhnout pro"),
                _createElementVNode("div", { class: "login-apps-button__text--bottom" }, "iOS")
              ], -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})